import { Tooltip } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteRandomControlProps } from './DeleteRandomControl.types';
import * as Styled from './DeleteRandomControl.styles';

export const DeleteRandomControl = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: DeleteRandomControlProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.KONTROLA]?.edit;
  const tooltipTitle = isPermsDisabled ? formatMessage({ id: AppMessages['common.noPermissions'] }) : '';

  return (
    <>
      <Tooltip placement="bottom-start" disableHoverListener={!isPermsDisabled} title={tooltipTitle}>
        <Styled.TrashIcon
          onClick={isPermsDisabled ? undefined : onModalOpen}
          tabIndex={isPermsDisabled ? -1 : 0}
          disabled={isPermsDisabled}
        />
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['control.deleteOwner.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
      >
        <ActionModal.Text>{formatMessage({ id: AppMessages['control.deleteOwner.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
